import React, { FC } from 'react'
import { Styled500 } from '.'

const FiveHundred: FC = () => {
  return (
    <Styled500>
      <h1>Oops! Something has gone wrong.</h1>
    </Styled500>
  )
}

export default FiveHundred
